import RevenueCard from "./RevenueCard";
import InfoTooltip from "../InfoTooltip";
import { trpc } from "../../trpc";

type RevenueRealSectionProps = {
  selectedMonth: string;
  selectedYear: string;
  trmValue: number;
  formatCurrency: (value: number) => string;
  formatUSD: (value: number) => string;
  revenueType?: string;
};

const RevenueRealSection = ({
  selectedMonth,
  selectedYear,
  trmValue,
  formatCurrency,
  formatUSD,
  revenueType,
}: RevenueRealSectionProps) => {
  const { data: realRevenueData, isLoading: isRealRevenueLoading } =
    trpc.revenue.realRevenue.useQuery(
      {
        year: parseInt(selectedYear),
        month: parseInt(selectedMonth),
        revenueType: revenueType === "all" ? undefined : revenueType,
      },
      {
        enabled: !!selectedMonth && !!selectedYear,
      }
    );

  const totalRevenue = realRevenueData?.totalRevenue || 0;
  const activeMerchants = realRevenueData?.activeMerchants || 0;
  const realMrr = totalRevenue / trmValue;
  const realArr = realMrr * 12;

  return (
    <div>
      <div className="mb-2">
        <p className="text-lg font-semibold text-gray-700 inline">
          Revenue basado en el consumo real del merchant - MRR real
        </p>
        <InfoTooltip
          text="Suma del consumo real de todos los merchants activos. Este valor representa el revenue real generado en el período seleccionado."
          placement="top"
          size="md"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 w-full">
        <RevenueCard
          title="Active Merchants"
          value={activeMerchants}
          subtitle="Merchants with consumption"
          isLoading={isRealRevenueLoading}
          formatValue={(value) => value.toString()}
        />

        <RevenueCard
          title="Total Real Revenue"
          value={totalRevenue}
          subtitle="Total real revenue (COP)"
          isLoading={isRealRevenueLoading}
          formatValue={formatCurrency}
        />

        <RevenueCard
          title="Real MRR"
          value={realMrr}
          subtitle="Monthly Recurring Revenue (USD)"
          isLoading={isRealRevenueLoading}
          formatValue={formatUSD}
        />

        <RevenueCard
          title="Real ARR"
          value={realArr}
          subtitle="Annual Recurring Revenue (USD)"
          isLoading={isRealRevenueLoading}
          formatValue={formatUSD}
        />
      </div>
    </div>
  );
};

export default RevenueRealSection;
